import {
  Card, CardContent, Box, Typography, Checkbox, IconButton, Button, Chip, Tooltip,
} from '@mui/material'
import { MoreVert, Star, OpenInNew } from '@mui/icons-material'
import StatusBadge from '../common/StatusBadge'
import { formatDate, formatNumber } from '../../utils/format'

export default function PlanCard({ plan, selected, onSelect, onOpen, onContextMenu }) {
  const {
    id, name, description, plant, status, isProductionPlan,
    createdBy, createdAt, modificationCount, totalCases12mo, totalECs12mo,
  } = plan

  const statusLabel = status === 'APPROVED' ? 'APPROVED' : 'DRAFT'

  return (
    <Card
      variant="outlined"
      onContextMenu={(e) => { e.preventDefault(); onContextMenu?.(e, plan) }}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderColor: selected ? 'primary.main' : undefined,
        borderWidth: selected ? 2 : 1,
        transition: 'border-color 0.15s, box-shadow 0.15s',
        '&:hover': { boxShadow: 2 },
      }}
    >
      <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Checkbox
            checked={!!selected}
            onChange={(e) => onSelect?.(plan, e.target.checked)}
            size="small"
            sx={{ mt: -0.5, ml: -0.5 }}
            onClick={(e) => e.stopPropagation()}
          />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="h6" noWrap>{name}</Typography>
          </Box>
          <IconButton
            size="small"
            onClick={(e) => onContextMenu?.(e, plan)}
          >
            <MoreVert fontSize="small" />
          </IconButton>
        </Box>

        {description && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {description}
          </Typography>
        )}

        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
          <Chip label={plant} size="small" variant="outlined" />
          <StatusBadge status={statusLabel} />
          {isProductionPlan && (
            <Tooltip title="Production Plan">
              <Chip
                icon={<Star sx={{ fontSize: 16, color: '#B45309' }} />}
                label="Production Plan"
                size="small"
                sx={{ bgcolor: 'warning.light', color: 'warning.dark', fontWeight: 600 }}
              />
            </Tooltip>
          )}
        </Box>

        <Typography variant="caption" color="text.secondary">
          Created by {createdBy || '—'} &middot; {formatDate(createdAt)}
        </Typography>

        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5, mt: 'auto', pt: 1 }}>
          <Typography variant="caption" color="text.secondary">
            Modifications: {modificationCount ?? 0}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'right' }}>
            Total Cases: {formatNumber(totalCases12mo)}
          </Typography>
          <Box />
          <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'right' }}>
            Total ECs: {formatNumber(totalECs12mo)}
          </Typography>
        </Box>

        <Button
          size="small"
          variant="contained"
          startIcon={<OpenInNew />}
          onClick={() => onOpen?.(id)}
          sx={{ mt: 1, alignSelf: 'flex-start' }}
        >
          Open
        </Button>
      </CardContent>
    </Card>
  )
}
